import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classNames from 'classnames';
import React, { Component } from 'react';
import TextareaAutoSize from 'react-textarea-autosize';
import LabelAndHint from '../LabelAndHint/LabelAndHint';
var css = {
  "inputDecorator": "rui-qJ0kn",
  "textarea": "rui-l9yV9"
};
var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);
  var _super = _createSuper(Textarea);
  function Textarea() {
    var _this;
    _classCallCheck(this, Textarea);
    _this = _super.apply(this, arguments);
    _this.onChangeTextArea = function (event) {
      var onChange = _this.props.onChange;
      onChange(event.target.value, event.target.name);
    };
    _this.renderInput = function (classname, icon, onFocus, onBlur) {
      var _this$props = _this.props,
        dataAutId = _this$props['data-aut-id'],
        id = _this$props.id,
        maxLength = _this$props.maxLength,
        minRows = _this$props.minRows,
        maxRows = _this$props.maxRows,
        name = _this$props.name,
        placeholder = _this$props.placeholder,
        value = _this$props.value;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextareaAutoSize, {
        minRows: minRows,
        maxRows: maxRows,
        autoComplete: "off",
        "data-aut-id": dataAutId,
        id: id,
        className: classNames(classname, css.textarea),
        maxLength: maxLength,
        name: name,
        onBlur: onBlur,
        onChange: _this.onChangeTextArea,
        onFocus: onFocus,
        placeholder: placeholder,
        value: value
      }), /*#__PURE__*/React.createElement("div", {
        className: css.inputDecorator
      }, icon));
    };
    return _this;
  }
  _createClass(Textarea, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        errorText = _this$props2.errorText,
        highlightOnBlur = _this$props2.highlightOnBlur,
        hintText = _this$props2.hintText,
        icon = _this$props2.icon,
        id = _this$props2.id,
        label = _this$props2.label,
        maxLength = _this$props2.maxLength,
        onBlur = _this$props2.onBlur,
        onFocus = _this$props2.onFocus,
        pristine = _this$props2.pristine,
        saveSpaceForIcons = _this$props2.saveSpaceForIcons,
        value = _this$props2.value;
      return /*#__PURE__*/React.createElement(LabelAndHint, {
        id: id,
        icon: icon,
        label: label,
        value: value,
        pristine: pristine,
        maxLength: maxLength,
        hintText: hintText,
        errorText: errorText,
        disabled: disabled,
        onBlur: onBlur,
        onFocus: onFocus,
        saveSpaceForIcons: saveSpaceForIcons,
        render: this.renderInput,
        highlightOnBlur: highlightOnBlur,
        roundedInputPixel: this.props.roundedInputPixel
      });
    }
  }]);
  return Textarea;
}(Component);
Textarea.defaultProps = {
  'data-aut-id': '',
  disabled: false,
  errorText: '',
  highlightOnBlur: false,
  hintText: '',
  icon: null,
  id: '',
  label: '',
  maxLength: 500,
  minRows: 3,
  maxRows: 10,
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  placeholder: '',
  pristine: true,
  saveSpaceForIcons: false,
  value: '',
  roundedInputPixel: false
};
export default Textarea;